<template>
  <div class="loading">
    <img src="@/assets/img/loading.gif" alt="">
  </div>
</template>

<script>
export default {
  name: "Loading",
  data () {
    return {}
  }
}
</script>

<style scoped  lang="less">
  .loading{
    position: fixed;
    top:0;
    left:0;
    z-index:11000;
    width: 100%;
    height: 100%;
    /*background: rgba(0,0,0,0.1);*/
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
  .loading img{
    width: 80px;
    height: 80px;
    margin:auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
    -o-transform: translate(-50%);
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);
    position: absolute;
  }
</style>
